import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router/index';
import CookieBanner from './components/feature/CookieBanner';
import AccessibilityWidget from './components/feature/AccessibilityWidget';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <div className="App">
        <AppRoutes />
        <CookieBanner />
        <AccessibilityWidget />
      </div>
    </BrowserRouter>
  );
}

export default App;